<template>
  <main>
    <umisis-top-nav />
    <div class="grid grid-cols-12 mt-5 gap-6 px-5">
      <Card class="col-span-12 lg:col-span-2">
        <UmisisSidebarNavigation />
      </Card>
      <Card class="p-8 col-span-12 lg:col-span-10">
        <router-view v-slot="{ Component, route }">
          <transition name="page-fade" mode="out-in">
            <component :is="Component" :key="route.path" />
          </transition>
        </router-view>
      </Card>
    </div>
    <div class="flex justify-center">
      <div class="md:flex text-xs text-gray-500 py-8 px-2 md:px-0 break-words space-x-4">
        <span>Umisis <span class="text-orange-600 font-bold">Core</span> SPA build with and Vue3, Laravel, Sanctum, Fortify, Pinia, Vue-Router and Tailwindcss</span>
      </div>
    </div>
    <UmisisChatDock />
  </main>
</template>

<script>
import UmisisTopNav from '@/components/umisis/navigation/UmisisTopNav.vue'
import { Card } from '@/components/ui/card/index.js'
import UmisisSidebarNavigation from '@/components/umisis/navigation/UmisisSidebarNavigation.vue'

export default {
  name: 'AuthenticatedLayout',
  components: {
    UmisisSidebarNavigation,
    Card,
    UmisisTopNav,
  }
}
</script>
